import type { LaunchDarklyContext, LaunchDarklyCustomer } from '../launch-darkly.types';

/**
 * Creates a context with the user data.
 *
 * @see {@link https://docs.launchdarkly.com/sdk/features/user-context-config#configuring-context-objects User and context configuration}
 */
export function generateUserContext(params: Params): LaunchDarklyContext {
  const { customer } = params;

  return {
    key: customer.id,
    email: customer.email,
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  customer: LaunchDarklyCustomer;
};
